import {parseToolResult} from "./codeExecution";
import type {MutationProposal} from "./mutationProposal";

/** Wingman wraps Galactus's {proposalId, status, result?} receipt in {completed, response}. */
export function readMutationExecution(result: unknown, proposal: MutationProposal): {saved: Record<string, unknown> | null} | null {
   const output = parseToolResult(result);
   const receipt = parseToolResult(output?.response);
   if (output?.completed !== true || output.unknown === true || (output.status !== undefined && output.status !== "executed") || output.error ||
      receipt?.proposalId !== proposal.proposalId || receipt.status !== "executed" || receipt.unknown === true || receipt.error) return null;
   // Galactus can omit an oversized result; the bound receipt still confirms execution.
   if (receipt.result === undefined) return {saved: null};
   const saved = parseToolResult(receipt.result);
   if (!saved || saved.id !== proposal.targetId || (proposal.capability === "use_cases_update" && (typeof saved.title !== "string" ||
      typeof saved.description !== "string" || !Array.isArray(saved.actions)))) return null;
   return {saved};
}
